import file from "./../../../components/Data/dataStatic";
import "./Polaroid.scss";

export default function Polaroid() {
  const fileJson = file[0]["publicaciones"];
  function SetRow({ name, index }) {
    var random = Math.floor(Math.random() * (3 - 1 + 1) + 1);
    return (
      <div className={`dv_${random} col-12 col-md-4 content_columns`}>
        <div key={index} className={"content_columns__recuadro"}>
          <span className="sub_content">
            <img src={name} alt="" />
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="container polaroid">
      <div className="main mt ml mr mb">
        <div className="content_proyect">
          <div className="row">
            {fileJson &&
              fileJson.map((item, index) => (
                <SetRow name={item?.name} index={index} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
